import { ICodeNameDto } from "../../../interface/dto/code-name.dto";
import { IRootState } from "../../../redux/root.reducer";
import { createIGSERedux } from "../../../shared/igse-redux/igse-redux-factory";
import { selectAuthTokens } from "../../auth/selectors/auth.selector";
import { getNAICSCodes } from "../service/naics-codes.api";

const {
    actions: naicsCodesActions,
    reducer: naicsCodesReducer,
    epic: naicsCodesEpic,
} = createIGSERedux<Array<ICodeNameDto>>({
    actionNames: {
        init: "NAICS_CODES_INIT",
        get: "NAICS_CODES_GET",
        success: "NAICS_CODES_SUCCESS",
        error: "NAICS_CODES_ERROR",
    },
    fetcher: () => getNAICSCodes(selectAuthTokens()),
    selector: (state: IRootState) => state.naicsCodes,
});

export { naicsCodesActions, naicsCodesReducer, naicsCodesEpic };
